module.exports = __webpack_public_path__ + "static/assets/637d5d767b1a3cd7dfe33b8db64927e6.png";